<template>
  <div class="srm-carousel-box" :class="{ 'dark-banner': dark }">
    <div class="carousel-box carousel-item" :style="{ backgroundImage: `url(${carouselInfo.bg})` }">
      <div class="content">
        <div class="title">{{carouselInfo.title}}</div>
        <div class="description" v-html="carouselInfo.description"></div>
      </div>
      <div v-if="isLink" class="click-button flex-box pointer" @click="toLink(linkMap.demonstrateUrl)">
        <span class="button-text">预约演示</span>
        <el-image :src="require('@/assets/images/link-to.png')" />
      </div>
    </div>
    <div class="carousel-option">
      <div
        v-for="(item, k) in carouselList"
        :key="k"
        class="option-item"
        @click="toLink(item.url)"
      >
        <div class="option-label">{{ item.label }}</div>
        <div class="option-subs list">
          <span v-for="(sub, si) in item.subs" :key="si">{{ sub }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { linkMap } from '@/utils'

export default {
  name: 'CarouselContainer',
  props: {
    isLink: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    carouselInfo: {
      require: true,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      carouselList: [
        {
          label: '化工材料行业',
          subs: ['涂料与油墨', '塑料与改性高分子', '电子化学品（半导体/面板材料）', '精细化工（表面活性剂、助剂、催化剂）', '工业胶粘剂与密封剂', '农化', '金属材料', '新能源材料与电池材料'],
          title: '化工材料研发一体化平台',
          description: '帮助客户实现实验、配方、工艺、成本等数据一体化管理，提升研发效率',
          url: '/ChemicalIndustry',
          img: require('@/assets/images/bg3.png')
        },
        {
          label: '食品饮料行业',
          subs: ['休闲零食', '饮料（含功能饮料）', '乳制品', '调味品', '预制菜 / 方便食品', '保健食品 / 功能食品', '宠物食品'],
          title: '食品饮料行业PLM解决方案',
          description: '通过PLM系统的数据管理、变更管理、项目管理等，实现跨部门地域的协同，让研发更快捷高效',
          url: '/FoodBeverage',
          img: require('@/assets/images/bg4.png')
        },
        {
          label: '日化美妆行业',
          subs: ['护肤品', '彩妆', '洗护用品', '口腔护理', '香氛', '家居清洁'],
          title: '日化美妆行业PLM解决方案',
          description: '通过PLM系统的数据管理、变更管理、项目管理等，实现跨部门地域的协同，让研发更快捷高效',
          url: '/BeautyMakeup',
          img: require('@/assets/images/bg4.png')
        },
        {
          label: '生命科学',
          subs: ['医疗器械', '制药', '医疗耗材', 'IVD试剂', '农药', '宠物药品'],
          title: '医疗器械行业PLM实施',
          description: '实现医疗行业的高效研发创新，缩短产品开发周期和研发成本',
          url: '/MedicalEquipment',
          img: require('@/assets/images/bg1.png')
        },
        {
          label: '离散行业',
          subs: ['芯片', '半导体', '3C电子'],
          title: '芯片半导体PLM解决方案',
          description: '帮助芯片半导体行业规范产品数据管理，实现研发全面信息化管理',
          url: '/Semiconductor',
          img: require('@/assets/images/bg2.png')
        },
        // {
        //   label: '机械制造',
        //   title: '工业制造PLM系统',
        //   description: '提升机械制造企业研发效率，帮助实现产品数据标准化、规范化，形成产品研发数据共享与传承',
        //   url: '/MachineryManufactur',
        //   img: require('@/assets/images/bg5.png')
        // }
      ],
      linkMap: linkMap,
    }
  },
  methods: {
    toLink(url) {
      window.open(url)
    },
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.srm-carousel-box {
  position: relative;
  .carousel-option {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: flex-start;
    gap: 2.4rem;
    width: 100%;
    padding: 1.6rem 1rem 2rem 20rem;
    box-sizing: border-box;
    background: transparent;
    .option-item {
      flex: 1;
      min-width: 0;
      cursor: pointer;
    }
    .option-label {
      font-size: 2.2rem;
      line-height: 3.2rem;
      margin-bottom: 1.2rem;
      color: #3674FE;
      font-weight: bold;
      // 贴边白影，不用大半径光晕，避免笔画发虚
      text-shadow: 0 0.1rem 0.2rem rgba(255, 255, 255, 0.75);
    }
    .option-item:hover .option-label {
      text-decoration: underline;
    }
    .option-subs {
      font-size: 1.6rem;
      line-height: 2.6rem;
      font-weight: 400;
      color: #333333;
      text-shadow: 0 0.1rem 0.2rem rgba(255, 255, 255, 0.75);
      &.list span {
        display: block;
      }
    }
  }
  .carousel-box {
    height: 100%;
    min-height: 70rem;
    padding: 10rem 8rem 36rem 12rem;
    background-size: 100% 100% !important;
    background-repeat: no-repeat!important;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .content {
      margin-bottom: 0;
      .title {
        font-size: 4.8rem;
        line-height: 7rem;
        font-weight: 600;
        color: #2E3F5E;
        margin-bottom: 2.3rem;
      }

      .description {
        font-weight: 400;
        font-size: 2.8rem;
        line-height: 4.2rem;
        color: #2E3F5E;
      }
    }

    .click-button {
      font-size: 2rem;
      line-height: 3rem;
      color: #FFF;
      background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
      box-shadow: 0 0.7rem 2.5rem 0 rgba(15,129,244,0.2);
      border-radius: 2.7rem;
      padding: 1.2rem 2.3rem;
      border: 0.1rem solid #FFFFFF;
      align-items: center;
      margin-top: 3.2rem;

      .button-text {
        margin-right: 0.8rem;
      }

      .el-image {
        width: 3rem;
        height: 3rem;
      }
    }
  }
  .carousel-item {
    .title {
      margin-bottom: 2.4rem!important;
    }
    .description {
      color: #333;
      width: 64.4rem;
    }
  }

  &.dark-banner {
    padding-top: 6.5rem;
    background-color: #f0f2f5;
    .carousel-box {
      position: relative;
      // 图片加载完成前的占位底色，避免白字直接落在浅灰背景上看不见
      background-color: #14283f;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 0;
        pointer-events: none;
        // 底部托住行业标签，左侧托住标题与正文，右侧透出原图
        background:
          linear-gradient(0deg, rgba(8, 18, 34, 0.72) 0%, rgba(8, 18, 34, 0) 42%),
          linear-gradient(90deg, rgba(8, 18, 34, 0.85) 0%, rgba(8, 18, 34, 0.62) 48%, rgba(8, 18, 34, 0) 84%);
      }

      .content,
      .click-button {
        position: relative;
        z-index: 1;
      }
    }
    .carousel-box .content {
      .title,
      .description {
        color: #fff;
        // 只保留贴边阴影：大半径的模糊阴影会把白色笔画边缘糊掉，反而显虚
        text-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.5);
      }
    }
    .carousel-item .description {
      color: #fff;
    }
    .option-label {
      color: #8ec5ff;
      text-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.65);
    }
    .option-subs {
      color: #fff;
      text-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.65);
    }
    .click-button {
      border-color: transparent;
    }
  }

}

@import "@/styles/mixins.scss";

@include mobile {
  .srm-carousel-box {
    &.dark-banner {
      padding-top: 5.6rem;
    }
    .carousel-option {
      display: flex;
      gap: 1.2rem;
      width: 100%;
      max-width: none;
      padding: 1.2rem 1.2rem 1.6rem;
      overflow-x: auto;
      .option-item {
        flex: 1 0 14rem;
        text-align: left;
      }
      .option-label {
        font-size: 1.3rem;
        line-height: 1.8rem;
        margin-bottom: 0.4rem;
      }
      .option-subs {
        font-size: 1.1rem;
        line-height: 1.6rem;
      }
    }

    .carousel-box {
      min-height: 52rem;
      padding: 7.2rem 1.6rem 22rem;
      background-size: cover !important;
      background-position: center center !important;
      overflow: hidden;
      justify-content: flex-start;

      .content {
        width: 100%;
        max-width: 100%;
        margin-bottom: 1.6rem;
        position: relative;
        z-index: 1;

        .title,
        .description {
          width: 100% !important;
          max-width: 100%;
          white-space: normal;
          word-break: break-word;
        }
        .title {
          font-size: 2.2rem;
          line-height: 3rem;
        }
        .description {
          font-size: 1.4rem;
          line-height: 2.2rem;
        }
      }

      .click-button {
        position: relative;
        z-index: 1;
        font-size: 1.4rem;
        padding: 1rem 1.6rem;
      }
    }

    .carousel-item .description {
      width: 100%;
    }
  }
}
</style>
